import React from 'react';

import { di } from 'react-magnetic-di';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditDateTimeInput } from './edit';
import { PreviewDateTimeInput } from './preview';
import { ViewDateTimeInput } from './view';

export const DateTimeInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormRenderMode);
	const renderMode = useFormRenderMode();

	switch (renderMode) {
		case FormRenderMode.EDIT:
			return (
				<EditDateTimeInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
		case FormRenderMode.PREVIEW:
			return (
				<PreviewDateTimeInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
		default:
			return (
				<ViewDateTimeInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
	}
};
